module.exports = __webpack_public_path__ + "static/scale-model-of-stanleyville-theater-in-tampa-florida-8d1e9d8fd99b978ed18f3c4d7b223645.png";